import { Copy } from '../i18n';

export function RiskNote({ copy }: { copy: Copy }) {
  return <p className="risk">{copy.risk}</p>;
}
